import { createContext } from "react";
import { CustomApiPageBloc } from "@uiview/pages/customApi/CustomApiPageBloc";
export const CustomApiPageBlocContext = createContext<CustomApiPageBloc>(new CustomApiPageBloc(""));
